// HeartPopup.jsx
import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import "./HeartPopup.css";
import heart from "../imagesHome/heart.png";

const HeartPopup = ({ livesCount }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [animateLoss, setAnimateLoss] = useState(false);
  const previousLivesCount = useRef(livesCount);

  const closePopup = () => {
    if (!isVisible) return;
    setIsOpen(false);
  };

  const openPopup = () => {
    if (isVisible && isOpen) return;
    setIsVisible(true);
    requestAnimationFrame(() => setIsOpen(true));
  };

  useEffect(() => {
    if (livesCount < previousLivesCount.current) {
      // utilizatorul a pierdut o viață
      setAnimateLoss(true);
      const timer = setTimeout(() => setAnimateLoss(false), 500);
      previousLivesCount.current = livesCount;
      return () => clearTimeout(timer);
    }

    previousLivesCount.current = livesCount;
  }, [livesCount]);

  useEffect(() => {
    if (!isVisible) return;

    const closeTimer = setTimeout(() => {
      if (!isOpen) {
        setIsVisible(false);
      }
    }, 280);

    return () => clearTimeout(closeTimer);
  }, [isVisible, isOpen]);

  useEffect(() => {
    if (!isVisible) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isVisible]);

  return (
    <div className="heart-popup-container">
      <button
        type="button"
        className="oiented-heart-track"
        onClick={isOpen ? closePopup : openPopup}
        aria-label="Deschide popup vieți"
      >
        <img
          src={heart}
          className={`heart-popup-icon ${animateLoss ? "heart-lost heart-shake" : ""}`}
          draggable={false}
          alt="Vieți"
        />

        <div className={`value-hearts ${animateLoss ? "heart-lost" : ""}`}>
          {livesCount}
        </div>
      </button>

      {isVisible &&
        createPortal(
          <>
            <div className={`heart-popup-overlay ${isOpen ? "open" : ""}`} onClick={closePopup} />
            <div
              className={`heart-popup ${isOpen ? "open" : ""}`}
              role="dialog"
              aria-modal="true"
              aria-label="Detalii vieți"
            >
              <button type="button" className="heart-popup-close" onClick={closePopup}>
                ×
              </button>
              <div className="heart-popup-content">
                <div className="heart-popup-number">{livesCount}</div>
                <img src={heart} className="heart-popup-bigicon" draggable={false} alt="Vieți" />
                <h3>Ai {livesCount} vieți</h3>
                <p>Folosește-le pentru a relua lecții sau a continua după greșeli.</p>
                <button type="button" className="heart-popup-btn">Cumpără vieți</button>
              </div>
            </div>
          </>,
          document.body
        )}
    </div>
  );
};

export default HeartPopup;
